<template>
  <div class="mxfw-wrap">
      <div class="mxfw-bg"></div>
      <div style="width:100%;height:43px"></div>
      <div class="mxfw">
          <div class="sta-title">
              名下房屋信息
          </div>
          <div class="sta-more">
              More
              <div class="sta-more1"></div>
          </div>
      </div>
      <div class="mxfw-items">
          <div class="mxfw-item-row" style="margin-bottom:40px;height: 171px">
              <div v-for="(item,index) in homeList1" :key="index" class="mxfw-item">
                  <div style="width:100%;height:23px"></div>
                  <div class="mxfw-item1">{{item.rowData.ASSET_NAME?item.rowData.ASSET_NAME:"信息理论技术教研2号楼"}}</div>
                  <div class="mxfw-item2">
                      <div class="mxfw-item21">203</div>
                      <div class="mxfw-item22">室</div>
                      <div class="mxfw-item23">{{Math.round(item.rowData.shul)+"m²"}}</div>
                  </div>
                  <div class="mxfw-item3">{{item.rowData.zcyt}}</div>
              </div>
          </div>
          <div class="mxfw-item-row">
              <div v-for="(item,index) in homeList2" :key="index" class="mxfw-item">
                  <div style="width:100%;height:23px"></div>
                  <div class="mxfw-item1">{{item.rowData.ASSET_NAME?item.rowData.ASSET_NAME:"信息理论技术教研2号楼"}}</div>
                  <div class="mxfw-item2">
                      <div class="mxfw-item21">203</div>
                      <div class="mxfw-item22">室</div>
                      <div class="mxfw-item23">{{Math.round(item.rowData.shul)+"m²"}}</div>
                  </div>
                  <div class="mxfw-item3">{{item.rowData.zcyt}}</div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  components:{
  },
  data () {
    return {
        homeList1:[],
        homeList2:[]
    }
  },
  methods: {
      getdanwei(danw){
          if(danw == '平方米'){
              return "m²"
          }else{
              return '台'
          }
      },
      getmxfw(){
          let paramter = {}
          GMS.$http.post('/own/home/list',paramter).then(res=>{
            if(res.status == 200){
                let data1 = res.data.extraData.slice(0,2)
                let data2 = res.data.extraData.slice(2,4)
                this.homeList1 = data1;
                this.homeList2 = data2;
            }
        }).catch(error => {
            // this.$Message.error("获取数据异常，请联系管理员");
        })
      }
  },
  mounted(){
      this.getmxfw()
  }
}
</script>

<style lang="less" scoped>
.mxfw-wrap{
    width: 100%;
    height: 271px;
    position: relative;
    .mxfw-bg{
        background: #fff none no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        background-image:url('../../../static/statistics/背景山@2x.webp');
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: -1;
    }
    .mxfw{
        width: 1200px;
        margin: 0 auto;
    }
    .sta-title{
        height: 42px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 30px;
        color: #424242;
        letter-spacing: 0;
        line-height: 42px;
        text-align: center;
        margin-bottom: 24px;
    }
    .sta-more{
        width: 39px;
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #7F7F7F;
        line-height: 22px;
        position: relative;
        margin: 0 auto;
        margin-bottom: 54px;
    }
    .sta-more1{
        position: absolute;
        left: 47px;
        bottom: 4px;
        width: 14px;
        height: 10px;  
        background: url('../../../static/statistics/more@2x.webp'); 
        background-size: 14px 10px;
    }
    .mxfw-items{
        position: absolute;
        width: 1200px;
        left: 50%;
        margin-left: -600px;
        top: 175px;
    }
    .mxfw-item{
        float: left;
        width: 580px;
        height: 171px;
        background: #FFFFFF;
        box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
        border-radius: 4px;
    }
    .mxfw-item:first-child{
        margin-right: 40px;
    }
    .mxfw-item-margin{
        margin-right: 40px;
    }
    .mxfw-item1{
        height: 25px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 18px;
        color: #0F0F0F;
        line-height: 25px;
        margin-left: 40px;
        margin-bottom: 10px;
    }
    .mxfw-item2{
        height: 56px;
        width: 230px;
        margin-left: 40px;
        margin-bottom: 17px;
    }
    .mxfw-item21{
        float: left;
        width: 72px;
        height: 56px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 40px;
        color: #003670;
        text-align: right;
        margin-right: 10px;
        line-height: 56px;
    }
    .mxfw-item22{
        float: left;
        width: 16px;
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #7F7F7F;
        margin-top: 25px;
        margin-right: 14px;
        line-height: 22px;
    }
    .mxfw-item23{
        float: left;
        width: 76px;
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #FF9D00;
        line-height: 22px;
        margin-top: 25px;
    }
    .mxfw-item3{
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #7F7F7F;
        line-height: 22px;
        margin-left: 40px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/mxfw.vue